import React, { useContext } from 'react'
import Context from '../context/Context'
import { isMobile } from 'react-device-detect'

const Header = () => {
  const context = useContext(Context)

  if (isMobile) {
    switch (context.style.positionOfLogo) {
    case 'left':
      return (
        <div className="container" style={{ background: context.organizationSettings.headerBackgroundColor }}>
          <div className="row">
            <div className="col offset-0">
              <img className="img-fluid logo" src={context.organizationSettings.logo} alt="" />
            </div>
          </div>
        </div>
      )
    case 'center':
      return (
        <div className="container" style={{ background: context.organizationSettings.headerBackgroundColor }}>
          <div className="row">
            <div className="col offset-2">
              <img className="img-fluid logo" src={context.organizationSettings.logo} alt="" />
            </div>
          </div>
        </div>
      )
    case 'right':
      return (
        <div className="container" style={{ background: context.organizationSettings.headerBackgroundColor }}>
          <div className="row">
            <div className="col offset-4">
              <img className="img-fluid logo" src={context.organizationSettings.logo} alt="" />
            </div>
          </div>
        </div>
      )
    default:
      return (
        <div className="container" style={{ background: context.organizationSettings.headerBackgroundColor }}>
          <div className="row">
            <div className="col offset-0">
              <img className="img-fluid logo" src={context.organizationSettings.logo} alt="" />
            </div>
          </div>
        </div>
      )
    }
  } else {
    switch (context.style.positionOfLogo) {
    case 'left':
      return (
        <div className="container" style={{ background: context.organizationSettings.headerBackgroundColor }}>
          <div className="row">
            <div className="col">
              <img className="img-fluid logo" src={context.organizationSettings.logo} alt="" />
            </div>
            <div className="col"></div>
            <div className="col"></div>
          </div>
        </div>
      )
    case 'center':
      return (
        <div className="container" style={{ background: context.organizationSettings.headerBackgroundColor }}>
          <div className="row">
            <div className="col"></div>
            <div className="col">
              <img className="img-fluid logo" src={context.organizationSettings.logo} alt="" />
            </div>
            <div className="col"></div>
          </div>
        </div>
      )
    case 'right':
      return (
        <div className="container" style={{ background: context.organizationSettings.headerBackgroundColor }}>
          <div className="row">
            <div className="col"></div>
            <div className="col"></div>
            <div className="col">
              <img className="img-fluid logo" src={context.organizationSettings.logo} alt="" />
            </div>
          </div>
        </div>
      )
    default:
      return (
        <div className="container">
          <div className="row">
            <div className="col">
              <img className="img-fluid logo" src={context.organizationSettings.logo} alt="" />
            </div>
            <div className="col"></div>
            <div className="col"></div>
          </div>
        </div>
      )
    }
  }
}

export default Header
